module.exports = __webpack_public_path__ + "img/18.c28d183e.png";